import { Button, Form, Input, message, Radio, Select } from 'antd';
import {
    getMasterSettingsData, FundAccountUpdatePayload, SelectPayload,
    SelectList, updateFundAccountMapping, getSourceAppNames, SourceAppNamelist, MstRequest
} from 'api/master';
import { UserPayload } from 'api/profile';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {
    isAdmin: boolean;
    onSubmit: (values: FundAccountUpdatePayload) => Promise<void>;
};

const updatePayload: FundAccountUpdatePayload = {};
const mstRequest: MstRequest = {};
const initPartners: SelectList[] = [];
const inituser: UserPayload = {};

const UpdateSource = ({ onSubmit }: Props) => {
    const navigate = useNavigate();
    const { Option } = Select;
    const [filter, setFilter] = useState(updatePayload);
    const [form] = Form.useForm<FundAccountUpdatePayload>();
    const [_user, _setUser] = useState(inituser);
    const [statusList, setStatusList] = useState<SelectList[]>(initPartners);
    const [statusId, setStatusId] = useState<number | undefined>();
    const [isSourceUpdate, setSourceUpdate] = useState(false);
    const [sourceAppNames, setSourceAppNames] = useState<SourceAppNamelist[]>([]);

    const location = useLocation();
    let state: any = location.state;
    debugger;
    console.log(state);

    useEffect(() => {
        const statusPayload: SelectPayload = {
            sKey: 'LoanType',
        };
        getMasterSettingsData(statusPayload).then((res) => {
            setStatusList(res.data);
        });
        getSourceAppNames(mstRequest).then((response) => {
            setSourceAppNames(response.data);
        });
    }, []);

    const handleSubmit = useCallback(
        async (values: FundAccountUpdatePayload) => {
            setSourceUpdate(true);
            if (values.chargesBearBy == '1' || values.chargesBearBy == 'A') { values.chargesBearBy = 'A'; } else { values.chargesBearBy = 'C'; }
            values.createdBy = sessionStorage.getItem('user')?.toString();
            values.loanType = values.loanType?.toString();
            values.fundAccMapId = state.FundAccMapID;
            values.sourceId = state.SourceId;

            if (values.isActive == true || values.isActive == undefined) { values.isActive = true } else { values.isActive = false; }
            updateFundAccountMapping(values)
                .then((_res) => {
                    if (_res.responseCode == '200' && _res.message == 'Data updated Succesfully!') {
                        message.success('Data is Updated Successfully!');
                    }
                    if (
                        _res.responseCode == '200' &&
                        (_res.message == 'Data Already Exists!' || _res.message == 'Some Error Occured!')
                    ) {
                        message.warn('Data Already Exists!');
                    }
                })
                .finally(() => {
                    form.resetFields();
                    setSourceUpdate(false);
                    navigate('/master/fundaccount');
                });
        },
        [onSubmit, form]
    );

    function handleReset(_e: any) {
        form.resetFields();
        let updatedFilter = { ...filter };
        updatedFilter = updatePayload;
        setFilter(updatedFilter);
        navigate('/master/fundaccount');
    }
    const handleStatusId = (value: number) => {
        form.setFieldValue('loanType', value);
        setStatusId(value);
    };


    const handleSourceNameChange = useCallback((value: any, option: any) => {
        debugger;
        state.SourceApplicationName = value;
        state.SourceId = option.key;
    }, [form]);

    return (
        <div className="container">
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <div className="mid-container">
                        <div className="submission-box">
                            <h2>Edit FundAccount</h2>
                            <div className="submission-htmlForm">
                                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                                <Form
                                    form={form}
                                    onFinish={handleSubmit}
                                    layout="vertical"
                                    scrollToFirstError
                                    className="standard-forms"
                                    initialValues={{
                                        ['Username']: sessionStorage.getItem('user')?.toString(),
                                        ['loanType']: state.LoanType,
                                        ['paymentPurpose']: state.PaymentPurpose,
                                        ['chargesBearBy']: state.ChargesBearBy === 'A' ? 1 : 0,
                                        ['receiptService']: state.ReceiptService,
                                        ['merchantId']: state.MerchantID,
                                        ['fundingAccount']: state.FundingAccount,
                                        ['razorPayKey']: state.RazorPayKey,
                                        ['razorPaySecret']: state.RazorSecret,
                                        ['sourcename']: state.SourceApplicationName,
                                        ['sourceid']: state.SourceId,
                                        ['isActive']: state.isActive,
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-6 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Loan Type :'}
                                                    name="loanType"
                                                    className="fieldTitle"
                                                    style={{ marginBottom: '20px' }}
                                                    rules={[{ required: true, message: 'Please select a loan type' }]}
                                                >
                                                    <Select
                                                        placeholder="Select"
                                                        size="large"
                                                        value={statusId}
                                                        onChange={handleStatusId}
                                                    >
                                                        {statusList.map((status) => (
                                                            <Option key={status.sKey} value={status.sVlue}>{status.sText}</Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Payment Purpose :'}
                                                    name="paymentPurpose"
                                                    className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please select a Payment Purpose' }]}
                                                >
                                                    <Select placeholder="Select" size="large">
                                                        <Option value="Fees">Fees</Option>
                                                        <Option value="Foreclosure">Foreclosure</Option>
                                                        <Option value="Overdue">Overdue</Option>
                                                        <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                                                        <Option value="PartPayment">PartPayment</Option>
                                                        <Option value="ADVANCEEMI">Advance EMI</Option>
                                                        <Option value="OtherCharges">Other Charges</Option>
                                                        <Option value="Post Disbursement">Post disbursement</Option>
                                                        <Option value="VAS">VAS</Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-6 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Charges Bear By :'} name="chargesBearBy" className="fieldTitle">
                                                    <Radio.Group onChange={(e) => form.setFieldsValue({ chargesBearBy: e.target.value === 1 ? 'A' : 'C' })}>
                                                        <Radio value={1}>Avanse</Radio>
                                                        <Radio value={0}>Company</Radio>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Receipt Service :'}
                                                    name="receiptService"
                                                    className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please select a Receipt Service' }]}
                                                >
                                                    <Select placeholder="Select" size="large">
                                                        <Option value="AllocatePayment">AllocatePayment</Option>
                                                        <Option value="EARLYSETTLEMENT">EARLYSETTLEMENT</Option>
                                                        <Option value="FEEPAYMENT">FEEPAYMENT</Option>
                                                        <Option value="IMD">IMD</Option>
                                                        <Option value="MANUALPAYMENT">MANUALPAYMENT</Option>
                                                        <Option value="PARTIALSETTLEMENT">PARTIALSETTLEMENT</Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Merchant ID :'} name="merchantId" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a Merchant ID' }]}>
                                                    <Input placeholder={'Merchant ID'} />
                                                </Form.Item>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'Funding Account :'} name="fundingAccount" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a Funding Account' }]}>
                                                    <Input placeholder={'Funding Account'} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'RazorPay Key :'} name="razorPayKey" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a RazorPay Key' }]}>
                                                    <Input placeholder={'RazorPay Key'} />
                                                </Form.Item>
                                            </div>
                                        </div>

                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item label={'RazorPay Secret :'} name="razorPaySecret" className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please enter a RazorPay Secret' }]}>
                                                    <Input placeholder={'RazorPay Secret'} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-md-6">
                                            <div className="input-box">
                                                <Form.Item
                                                    label={'Source Application Name:'}
                                                    name="sourcename"
                                                    className="fieldTitle"
                                                    rules={[{ required: true, message: 'Please select a Source Application Name:' }]}>
                                                    <Select placeholder="Select" size="large" onChange={handleSourceNameChange}>
                                                        {sourceAppNames.map((app) => (
                                                            <Option key={app.sourceId} value={app.sourceApplicationName}>
                                                                {app.sourceApplicationName}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-4">
                                            <div className="input-box">
                                                <Form.Item label={'Type :'} name="isActive" className="fieldTitle">
                                                    <Radio.Group
                                                        defaultValue={true} // Set the default value based on the state
                                                        onChange={(e) => form.setFieldsValue({ isActive: e.target.value })} // Update the form field value on change
                                                    >
                                                        <label
                                                            className="btn btn-primary col-md-2"
                                                            style={{ marginRight: '10px', marginBottom: '20px' }}
                                                        >
                                                            <Radio
                                                                className="rblFeeType"
                                                                id="appTypeActive"
                                                                name="isActive"
                                                                type="radio"
                                                                value={true}
                                                                style={{ width: '600px', color: 'white', fontWeight: '' }}
                                                            >
                                                                Active
                                                            </Radio>
                                                        </label>
                                                        <label
                                                            className="btn btn-primary col-md-2"
                                                            style={{ marginRight: '10px', marginBottom: '20px' }}
                                                        >
                                                            <Radio
                                                                className="rblFeeType"
                                                                id="appTypeInactive" // Unique id for each radio button
                                                                name="isActive"
                                                                type="radio"
                                                                value={false}
                                                                style={{ width: '300px', color: 'white' }}
                                                            >
                                                                Inactive
                                                            </Radio>
                                                        </label>
                                                    </Radio.Group>
                                                </Form.Item>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="payment-button">
                                        <Button
                                            className="proceed-btn"
                                            id="btnSubmit"
                                            htmlType="submit"
                                            size="small"
                                            disabled={isSourceUpdate ? true : false}
                                        >
                                            UPDATE
                                        </Button>

                                        <Button
                                            id="btnClear"
                                            className="proceed-btn"
                                            size="small"
                                            style={{ marginLeft: '10px' }}
                                            onClick={handleReset}
                                        >
                                            BACK
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateSource;
